import { render, staticRenderFns } from "./vsNavGroup.vue?vue&type=template&id=2d6da28e&"
import script from "./vsNavGroup.vue?vue&type=script&lang=js&"
export * from "./vsNavGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsNavGroup.vue"
export default component.exports